import { SlidersHorizontalIcon } from "@phosphor-icons/react/dist/csr/SlidersHorizontal";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { RunGoalStatus } from "@/profitability/goal-checks";
import { SettingsUsed } from "@/profitability/settings";
import type { ProfitabilityRun, ReportOutput } from "@/profitability/types";

/**
 * What a run was held to, beside its figures: the owner's own numbers for
 * the period when they gave them, and the template settings its script read
 * with the value each had for this run. Nothing when it has neither.
 */
export const RunChecksStrip = ({
  run,
  output,
}: {
  run: Pick<ProfitabilityRun, "goal_checks">;
  output: Pick<ReportOutput, "settings"> | undefined;
}) => {
  const settings = output?.settings ?? [];
  if (!run.goal_checks && !settings.length) return null;
  return (
    <Stack direction="row" gap={2} align="center" className="mb-4 flex-wrap">
      {run.goal_checks && <RunGoalStatus checks={run.goal_checks} />}
      {settings.length > 0 && (
        <SettingsUsed
          settings={settings}
          trigger={
            <Button size="sm" variant="ghost">
              <SlidersHorizontalIcon />
              Settings used
            </Button>
          }
        />
      )}
    </Stack>
  );
};
